module.exports = __webpack_public_path__ + "img/manage-img1.5a46c501.png";